import "reflect-metadata";

/**
 * Mongo native format, must be also indexed as 2dsphere to work
 */
export class MongoMultiPointLocation {
  public constructor(coordinates: Array<Array<number>>) {
    this.type = "MultiPoint";
    this.coordinates = coordinates;
  }

  public type: string = "MultiPoint";

  /**
   * [ [ longitude, latitude ], [ longitude, latitude ] ]
   */
  public coordinates: Array<Array<number>>;
}
